import styled from 'styled-components'

export const Banner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 8px;
  border: 1px solid #b6dbfb;
  border-radius: 8px;
  background: #e7f3fe;
  margin: 22px 0 6px;
`

export const BannerIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #213f68;

  svg {
    width: 14px;
    height: 14px;
    font-size: 14px;
  }
`

export const BannerText = styled.p`
  margin: 0;
  flex: 1;
  min-width: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-break: break-word;
`
